<template>
  <nav class="nav" :class="navBgClass">
    <div class="nav-wrap">
      <!-- Logo区域 -->
      <div class="nav-logo">
        <img src="@/assets/logo.png" alt=""/>
        <span>多洗爱车</span>
      </div>

      <!-- PC端横向菜单+下单按钮 -->
      <section class="nav-menu-wrap pc-menu">
        <div class="nav-menu">
          <router-link to="/home">首页</router-link>
          <router-link to="/about">了解我们</router-link>
          <router-link to="/join">招商合作</router-link>
        </div>
        <button class="nav-btn" @click="openOrder">立即下单</button>
      </section>

      <!-- 手机端汉堡菜单按钮（图片） -->
      <div class="mobile-hamburger" @click="drawer = true">
        <img src="@/assets/hamburgerMenu.png" alt="菜单"/>
      </div>
    </div>

    <!-- ElementUI 右侧抽屉 完全适配设计图 -->
    <el-drawer
      :visible.sync="drawer"
      direction="rtl"
      width="100%"
      size="100%"
      :show-close="true"
      :before-close="handleCloseDrawer"
      :close-on-click-mask="true"
      append-to-body
    >
      <div class="drawer-content">
        <router-link to="/home" @click.native="closeDrawer">首页</router-link>
        <router-link to="/about" @click.native="closeDrawer">了解我们</router-link>
        <router-link to="/join" @click.native="closeDrawer">招商合作</router-link>
        <button class="drawer-btn" @click="openOrder">立即下单</button>
      </div>
    </el-drawer>
  </nav>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      scrollTop: 0,
      drawer: false,
    }
  },
  computed: {
    navBgClass() {
      const isHome = this.$route.path === '/home'
      if (isHome && this.scrollTop < 20) {
        return 'nav-banner'
      }
      return 'nav-white'
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.scrollTop = window.scrollY
    },
    openOrder() {
      this.$root.$emit("openOrder");
      this.closeDrawer()
    },
    // 统一关闭抽屉
    closeDrawer() {
      this.drawer = false
    },
    handleCloseDrawer(done) {
      done();
    }
  },
};
</script>

<style scoped lang="scss">
.nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  transition: background 0.3s ease;

  &.nav-banner {
    background: url("@/assets/navBar.png") center / cover no-repeat;
    box-shadow: none;
  }
  &.nav-white {
    background-color: #ffffff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  }
}

// PC菜单文字穿透样式
:deep(.nav-logo span) {
  color: #333333;
}
:deep(.nav-menu a) {
  color: #333333;
  text-decoration: none;
  &.router-link-active {
    color: #4172F0;
    border-bottom: 0.2vw solid #4172F0;
  }
}

.nav-wrap {
  width: 65%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 3vw;
  padding: 1vw 0;
  gap: 2vw;
}

.nav-logo {
  font-size: 1.2vw;
  font-weight: 700;
  display: flex;
  gap: 0.3vw;
  white-space: nowrap;
  img {
    width: 1.88vw;
    height: 1.88vw;
  }
}

.pc-menu {
  display: flex;
  align-items: center;
  gap: 2vw;
  flex-wrap: nowrap;
  justify-content: flex-end;
}

.nav-menu {
  display: flex;
  gap: 0.5vw;
  align-items: center;
  flex-wrap: nowrap;
  a {
    text-decoration: none;
    font-size: 0.9vw;
    margin: 0 1.15vw;
    padding: 0.5vw 0;
    white-space: nowrap;
  }
}

.nav-btn {
  padding: 0.42vw 1.04vw;
  background-color: #4172F0;
  color: #fff;
  border: none;
  border-radius: 0.42vw;
  cursor: pointer;
  font-size: 0.9vw;
  font-weight: normal;
  white-space: nowrap;
}

// 汉堡图片按钮
.mobile-hamburger {
  display: none;
  cursor: pointer;
  img {
    width: 9vw;
    height: auto;
    display: block;
  }
}
// 抽屉内部布局 完全匹配产品图
.drawer-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12vw;
  padding: 28vw 4vw 0 4vw;
  a {
    font-size: 5vw;
    color: #333;
    text-decoration: none;
    padding-bottom: 1vw;
  }
  // 当前页面高亮蓝色下划线
  a.router-link-active {
    color: #4172F0;
    border-bottom: 2px solid #4172F0;
  }
}
.drawer-btn {
  padding: 2vw 6vw;
  background: #4172F0;
  color: #fff;
  border: none;
  border-radius: 1vw;
  font-size: 4vw;
  margin-top: 5vw;
}

// ========== 手机适配（768px以下） ==========
@media (max-width: 768px) {
  .nav {
    &.nav-banner {
    background: url("@/assets/navBarX.png") center / cover no-repeat;
    box-shadow: none;
  }
  }
  .nav-wrap {
    width: 94%;
    min-height: auto;
    padding: 3vw;
  }

  .nav-logo {
    font-size: 5vw;
    
    img {
      width: 8vw;
      height: 8vw;
    }
  }

  .pc-menu {
    display: none;
  }
  .mobile-hamburger {
    display: block;
  }
}
</style>